import { useDndMonitor } from '@dnd-kit/core'
import { useEffect, useState } from 'react'
import { Dimensions, Range } from 'types'
import { HANDLE_MID } from 'ui/src/components/controls/range-slider/dnd/style'
import { MediaInfo } from '../../../types'
import Canvas from './canvas'
import { Container, Dim } from './style'

type Props = {
    backgroundColor: string
    className?: string
    dimensions: Dimensions
    dndId: string
    loops?: number
    mediaInfo: MediaInfo
    range: Range
    reversed?: boolean
    source: File | string
}

const MediaTrimmerStrip = ({
    backgroundColor,
    className,
    dimensions,
    dndId,
    loops,
    mediaInfo,
    range,
    reversed,
    source,
}: Props) => {
    const [drag, setDrag] = useState<Range>(range)
    const dimStartWidth = Math.round(drag.start * (dimensions.width - HANDLE_MID))
    const dimEndWidth = Math.round((1 - drag.end) * (dimensions.width - HANDLE_MID))

    useDndMonitor({
        onDragMove({ active: { data } }) {
            if (data.current?.controlId !== dndId) return

            if (data.current?.controlValue) {
                setDrag(data.current?.controlValue as Range)
            }
        },
    })

    useEffect(() => {
        setDrag(range)
    }, [range.end, range.start])

    return (
        <Container className={className}>
            <Canvas dimensions={dimensions} loops={loops} mediaInfo={mediaInfo} reversed={reversed} source={source} />
            <Dim style={{ backgroundColor, left: 0, width: dimStartWidth }} />
            <Dim style={{ backgroundColor, right: 0, width: dimEndWidth }} />
        </Container>
    )
}

export default MediaTrimmerStrip
